import { facadeApiV3 } from './facadeApiV3';

export const enhancedFacadeApiV3 = facadeApiV3.enhanceEndpoints({
    endpoints: {
        getTours: { providesTags: ['TourList'] },
        canceledTour: { invalidatesTags: ['TourList'] },
        createTour: { invalidatesTags: ['TourList'] },
        updateTour: { invalidatesTags: ['TourList'] },
        sendTourToVehicle: { invalidatesTags: ['TourList'] },
    },
});

export const { useGetToursQuery, useCanceledTourMutation } = enhancedFacadeApiV3;
